import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyAUaHnxMMK-_1RmXuI4bFF1Bhc2qV9IfKs",
  authDomain: "cassia-572bc.firebaseapp.com",
  projectId: "cassia-572bc",
  storageBucket: "cassia-572bc.firebasestorage.app",
  messagingSenderId: "137895552550",
  appId: "1:137895552550:web:bcd91b1ba6ab86c5ff28e7",
  measurementId: "G-LGD7SE4K21"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Analytics (only in browser)
let analytics = null
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

// Initialize Firestore
const db = getFirestore(app)

// Initialize Auth
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

export { app, analytics, db, auth, googleProvider }
